import { useEffect, useRef } from "react";

function getStarTint(): string {
	const shouldUseColoredStar = Math.random() < 0.18;
	if (!shouldUseColoredStar) return "rgba(255,255,255,.92)";

	const shouldUseCyan = Math.random() < 0.5;
	if (shouldUseCyan) return "rgba(56,225,255,.9)";

	return "rgba(255,120,180,.9)";
}

function Stars({ className = "" }: Readonly<{ className?: string }>) {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		el.innerHTML = "";

		for (let i = 0; i < 150; i++) {
			const s = document.createElement("span");
			const size = Math.random() < 0.85 ? Math.random() * 1.6 + 1 : Math.random() * 2.2 + 2.4;
			const dur = (Math.random() * 3 + 2.4).toFixed(2);
			const delay = (Math.random() * 5).toFixed(2);
			const tint = getStarTint();

			s.style.cssText =
				`position:absolute;border-radius:50%;` +
				`left:${(Math.random() * 100).toFixed(2)}%;top:${(Math.random() * 100).toFixed(2)}%;` +
				`width:${size.toFixed(2)}px;height:${size.toFixed(2)}px;background:${tint};` +
				`box-shadow:0 0 ${(size * 2.5).toFixed(1)}px ${tint};` +
				`animation:scTwinkle ${dur}s ease-in-out ${delay}s infinite;`;

			el.appendChild(s);
		}

		return () => {
			el.innerHTML = "";
		};
	}, []);

	return <div ref={ref} aria-hidden className={`pointer-events-none absolute inset-0 ${className}`} />;
}

export default Stars;
